var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.87914 3.5985C4.52559 3.24496 3.95238 3.24496 3.59884 3.5985C3.24529 3.95205 3.24529 4.52526 3.59884 4.8788L8.72008 10L3.59891 15.1212C3.24536 15.4748 3.24536 16.048 3.59891 16.4015C3.95245 16.7551 4.52566 16.7551 4.87921 16.4015L10.0004 11.2803L15.1215 16.4015C15.4751 16.7551 16.0483 16.7551 16.4019 16.4015C16.7554 16.048 16.7554 15.4748 16.4019 15.1212L11.2807 10L16.4019 4.87881C16.7555 4.52526 16.7555 3.95205 16.4019 3.5985C16.0484 3.24496 15.4752 3.24496 15.1216 3.5985L10.0004 8.71974L4.87914 3.5985Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModal);
export default __webpack_public_path__ + "static/media/closeModal.d560b19bc68f349025328b53d20247dc.svg";
export { ForwardRef as ReactComponent };